export const LOADED_USER_GROUPS = 'project/groups/loaded-user-groups';
export const UPDATE_LOADED_GROUP ='project/groups/update-loaded-group'
export const DELETED_GROUP = 'project/groups/deleted-group'
export const ADDED_USER_GROUP = 'project/groups/added-user-group';
export const REMOVED_USER_GROUP = 'project/groups/removed-user-group';
export const LOADED_GROUP_SEARCH = 'project/groups/loaded-group-search';
export const NEW_PAGE_GROUP_SEARCH = 'project/groups/new-page-group-search';
export const UPDATE_SEARCHED_GROUP = 'project/groups/update-searched-group';
export const ASKED_NEW_GROUP = 'project/groups/asked_new_group';
export const ADD_NEW_INVITE = 'project/groups/add_new_invite';
export const DELETE_INVITE = 'project/groups/delete_invite';
